// import { NAV_DATA } from "./navData";

// /*
//   Add the searchable text of every routed page here. A React SPA cannot read an
//   unmounted route's rendered DOM, so site-wide search needs an index like this.

//   Keep `path` exactly the same as the path used in <Route path="...">.

//   Example:
//   {
//     title: "About ASSOCHAM",
//     path: "/about-us",
//     keywords: ["about", "chamber", "history", "vision", "mission"],
//     content: `Paste the page's visible text here, or import the same content
//               object that the page component renders.`
//   }

//   Pages present in NAV_DATA are included automatically by the code below. Add
//   them here too when you want their complete body text to be searchable; records
//   with the same path are merged.
// */
// export const PAGE_SEARCH_DATA = [
//   // Add one object per route.
// ];

// const asText = (value) => {
//   if (Array.isArray(value)) return value.join(" ");
//   return value == null ? "" : String(value);
// };

// const isSearchablePath = (path) =>
//   typeof path === "string" && path.trim() !== "" && path !== "#";

// const navRecords = [];

// const walkNav = (items = [], parents = []) => {
//   items.forEach((item) => {
//     if (!item || typeof item === "string") return;

//     const title = item.label || item.title || "";
//     const path = item.href || item.path || "";
//     const parentKeywords = parents.filter(Boolean);

//     if (title && isSearchablePath(path)) {
//       navRecords.push({
//         title,
//         path,
//         keywords: [
//           ...parentKeywords,
//           ...(
//             Array.isArray(item.keywords)
//               ? item.keywords
//               : [item.keywords]
//           ).filter(Boolean),
//         ],
//         content: item.searchContent || item.content || "",
//       });
//     }

//     const nextParents = title ? [...parents, title] : parents;
//     if (Array.isArray(item.items)) walkNav(item.items, nextParents);
//     if (Array.isArray(item.councils)) walkNav(item.councils, nextParents);
//   });
// };

// walkNav(NAV_DATA);

// // Merge duplicate paths so the nav title/keywords and complete page body can
// // contribute to one search result.
// const mergedByPath = new Map();

// [...navRecords, ...PAGE_SEARCH_DATA].forEach((record) => {
//   const path = record?.path || record?.href;
//   if (!record?.title || !isSearchablePath(path)) return;

//   const existing = mergedByPath.get(path);
//   if (!existing) {
//     mergedByPath.set(path, {
//       title: record.title,
//       path,
//       keywords: asText(record.keywords),
//       content: asText(record.content),
//     });
//     return;
//   }

//   mergedByPath.set(path, {
//     title: record.title || existing.title,
//     path,
//     keywords: `${existing.keywords} ${asText(record.keywords)}`.trim(),
//     content: `${existing.content} ${asText(record.content)}`.trim(),
//   });
// });

// export const SEARCH_DATA = Array.from(mergedByPath.values());





// new new code 



import { normalize, flattenText } from "../utils/searchText";

// Named import: SectorsData.js exports SECTORS (keyed by council slug).
import { SECTORS } from "../components/Sectors/SectorsData";

const API_BASE = "https://assocham.org/assocham_backend/api";
const MAX_CONTENT = 1200;

/* ------------------------------------------------------------------ */
/* Helpers                                                             */
/* ------------------------------------------------------------------ */

export const CATEGORY_ORDER = [
  "Events",
  "News",
  "Reports",
  "Publications",
  "Global Research",
  "Knowledge Center",
  "International",
  "States",
  "Sectors",
  "Membership",
  "About",
  "Pages",
];

const slugify = (value = "") =>
  String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const humanize = (slug = "") =>
  slug.replace(/[-_]+/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

// Adds the pre-normalized fields so scoring is cheap on every keystroke.
const indexPage = (page, id) => {
  const keywords = Array.isArray(page.keywords)
    ? page.keywords.join(" ")
    : page.keywords || "";
  const content = page.content || "";

  return {
    ...page,
    id,
    keywords,
    content,
    _title: normalize(page.title),
    _keywords: normalize(`${page.category} ${keywords}`),
    _content: normalize(content),
    _all: normalize(`${page.title} ${page.category} ${keywords} ${content}`),
  };
};

const page = (title, path, category, keywords = "", content = "") => ({
  title,
  path,
  category,
  keywords,
  content,
});

/* ------------------------------------------------------------------ */
/* Static pages (every route in App.jsx)                               */
/* ------------------------------------------------------------------ */

const ROUTE_PAGES = [
  page("Home", "/", "Pages", "home main homepage", "ASSOCHAM home page"),
  page("Knowledge Report", "/knowledge-report", "Reports", "report knowledge", "Knowledge reports section"),
  page("About Us", "/about-us", "About", "about assocham history mission vision", "About ASSOCHAM, its mission, vision and history"),
  page("Leadership", "/about/leadership", "About", "president secretary general leaders management", "ASSOCHAM leadership and office bearers"),
  page("Our Team", "/about/our-team", "About", "team staff members", "ASSOCHAM team members"),
  page("Past Presidents", "/about/past-president", "About", "past president former", "Past presidents of ASSOCHAM"),
  page("Annual Return", "/annual-return", "About", "finance annual return accounts financial", "Annual return and finance documents"),
  page("Membership", "/membership", "Membership", "member join benefits", "Become a member of ASSOCHAM"),
  page("Membership Overview", "/overview", "Membership", "membership overview", "Overview of ASSOCHAM membership"),
  page("Membership Plans", "/membership-plans", "Membership", "plans fees subscription", "Membership plans and fees"),
  page("Press Release", "/newsroom/press-release", "News", "press release newsroom media", "Latest press releases"),
  page("Press Coverage", "/newsroom/press-coverage", "News", "press coverage media news articles", "ASSOCHAM in the news"),
  page("Image Library", "/newsroom/image-library", "News", "gallery photos images albums", "Photo gallery and image library"),
  page("Global Research", "/global-research", "Global Research", "research global economy", "Global research overview"),
  page("Economic Growth & Development", "/global-research/economic-growth", "Global Research", "economic growth development egd", "Economic growth and development research"),
  page("Ease of Doing Business", "/global-research/eodb", "Global Research", "eodb ease of doing business", "Ease of doing business research"),
  page("TIPS", "/global-research/tips", "Global Research", "tips investment promotion", "TIPS research and overview"),
  page("Publications", "/global-research/publications", "Publications", "publication publications documents", "Global research publications"),
  page("Knowledge Center", "/overview-knowledge-center", "Knowledge Center", "knowledge center overview", "Knowledge center overview"),
  page("Knowledge Reports", "/knowledge/reports", "Reports", "reports knowledge studies", "ASSOCHAM knowledge reports"),
  page("ASSOCHAM Voice", "/knowledge/assocham-voice", "Knowledge Center", "voice magazine", "ASSOCHAM Voice"),
  page("Bulletins", "/knowledge/bulletins", "Knowledge Center", "bulletin newsletter", "ASSOCHAM bulletins"),
  page("AFCSR", "/afcsr", "Pages", "afcsr csr corporate social responsibility", "Corporate social responsibility (AFCSR)"),
  page("Events", "/events", "Events", "events upcoming conference summit seminar", "All ASSOCHAM events"),
  page("International", "/international", "International", "international outreach partnerships global offices", "International outreach and partnerships"),
  page("Privacy Policy", "/privacy-policy", "Pages", "privacy policy data terms", "Privacy policy"),
  page("Career", "/career", "Pages", "career jobs vacancies hiring", "Careers at ASSOCHAM"),
];

/* ------------------------------------------------------------------ */
/* States (route: /:stateSlug)                                         */
/* ------------------------------------------------------------------ */

const STATES = [
  "Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar",
  "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa",
  "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka",
  "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
  "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
];

// If a slug in your `regions` table differs from slugify(name), override it here.
const STATE_SLUG_OVERRIDES = {
  // "Jammu and Kashmir": "jammu-kashmir",
};

const STATE_PAGES = STATES.map((name) =>
  page(
    name,
    `/${STATE_SLUG_OVERRIDES[name] || slugify(name)}`,
    "States",
    `${name} state region chapter office`,
    `ASSOCHAM ${name}: state overview, events, activities and contacts`
  )
);

/* ------------------------------------------------------------------ */
/* Sectors / councils (route: /sectors/:councilSlug)                   */
/* ------------------------------------------------------------------ */

const TITLE_KEYS = [
  "title", "head_title", "name", "heading", "headline",
  "event_title", "event_name", "eventName", "sector_name", "label",
];

const pickText = (record, keys) => {
  for (const key of keys) {
    const value = record?.[key];
    if (typeof value === "string" && value.trim()) {
      return value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    }
  }
  return "";
};

const SECTORS_SOURCE = SECTORS || {};

const sectorEntries = Array.isArray(SECTORS_SOURCE)
  ? SECTORS_SOURCE.map((sector) => [sector?.slug, sector])
  : Object.entries(SECTORS_SOURCE);

const SECTOR_PAGES = sectorEntries
  .filter(([slug, sector]) => slug && sector && typeof sector === "object")
  .map(([slug, sector]) =>
    page(
      pickText(sector, TITLE_KEYS) || humanize(slug),
      `/sectors/${slug}`,
      "Sectors",
      `${humanize(slug)} council sector`,
      flattenText(sector).join(" ").slice(0, MAX_CONTENT)
    )
  );

/* ------------------------------------------------------------------ */
/* Static index (available immediately)                                */
/* ------------------------------------------------------------------ */

export const STATIC_PAGES = [...ROUTE_PAGES, ...STATE_PAGES, ...SECTOR_PAGES].map(
  (item, index) => indexPage(item, `static-${index}`)
);

// Backward compatible export name.
export const SEARCH_DATA = STATIC_PAGES;

/* ------------------------------------------------------------------ */
/* Remote data (loaded lazily from the PHP backend)                    */
/* ------------------------------------------------------------------ */

// To add more data (reports, publications, international events...):
// copy one object below, set the endpoint, category, and the routes.
//   basePath : detail route prefix, used when the record has a `slug`
//   listPath : listing page used as a fallback (opens with ?q=<title>)
const REMOTE_SOURCES = [
  {
    id: "events",
    category: "Events",
    endpoint: `${API_BASE}/get_events.php`,
    basePath: "/event-details/",
    listPath: "/events",
  },
  {
    id: "press-releases",
    category: "News",
    endpoint: `${API_BASE}/get_press_releases.php`,
    basePath: "/press-release/",
    listPath: "/newsroom/press-release",
  },
  {
    id: "press-coverage",
    category: "News",
    endpoint: `${API_BASE}/get_press_coverages.php`,
    listPath: "/newsroom/press-coverage",
  },
  // Example template (fill the real endpoint name, then uncomment):
  // {
  //   id: "publications",
  //   category: "Publications",
  //   endpoint: `${API_BASE}/get_knowledge_publications.php`,
  //   listPath: "/global-research/publications",
  // },
];

const PREFERRED_KEYS = ["data", "items", "events", "results", "records", "rows", "list"];

// Finds the first array of objects inside any JSON response shape.
const extractRecords = (json, depth = 0) => {
  if (Array.isArray(json)) {
    return json.filter((item) => item && typeof item === "object");
  }
  if (!json || typeof json !== "object" || depth > 2) return [];

  for (const key of PREFERRED_KEYS) {
    if (json[key]) {
      const found = extractRecords(json[key], depth + 1);
      if (found.length) return found;
    }
  }
  for (const value of Object.values(json)) {
    const found = extractRecords(value, depth + 1);
    if (found.length) return found;
  }
  return [];
};

const IMAGE_RE = /\.(?:png|jpe?g|webp|svg|gif|avif)(?:$|[?#])/i;
const LINK_KEYS = [
  "externalUrl", "read_more_link", "pdf", "pdfUrl", "pdf_link",
  "file", "fileUrl", "link", "url", "href",
];

const pickExternalLink = (record) => {
  for (const key of LINK_KEYS) {
    const value = record?.[key];
    if (
      typeof value === "string" &&
      /^https?:\/\//i.test(value.trim()) &&
      !IMAGE_RE.test(value)
    ) {
      return value.trim();
    }
  }
  return "";
};

const toRemotePage = (source, record, index) => {
  const title = pickText(record, TITLE_KEYS);
  if (!title) return null;

  const slug = pickText(record, ["slug"]);
  let path;

  if (source.basePath && slug) {
    path = `${source.basePath}${encodeURIComponent(slug)}`;
  } else {
    path =
      pickExternalLink(record) ||
      `${source.listPath}?q=${encodeURIComponent(title)}`;
  }

  return indexPage(
    {
      title,
      path,
      category: source.category,
      keywords: source.category,
      content: flattenText(record).join(" ").slice(0, MAX_CONTENT),
    },
    `${source.id}-${index}`
  );
};

// One cached promise per source. A failed source is dropped so it retries next time.
const sourceCache = new Map();

const fetchSource = (source) => {
  if (sourceCache.has(source.id)) return sourceCache.get(source.id);

  const request = fetch(source.endpoint, { headers: { Accept: "application/json" } })
    .then((response) => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    })
    .then((json) =>
      extractRecords(json)
        .map((record, index) => toRemotePage(source, record, index))
        .filter(Boolean)
    )
    .catch(() => {
      sourceCache.delete(source.id);
      return [];
    });

  sourceCache.set(source.id, request);
  return request;
};

export const loadRemoteSearchPages = async () => {
  const groups = await Promise.all(REMOTE_SOURCES.map(fetchSource));
  return groups.flat();
};